import { createSlice } from '@reduxjs/toolkit';

const getChatId = (a, b) => [a, b].sort().join('_');

const sortByCreatedAt = (a, b) =>
  new Date(a.createdAt || a.created_at || 0) - new Date(b.createdAt || b.created_at || 0);

const upsert = (arr, msg) => {
  const list = Array.isArray(arr) ? [...arr] : [];
  const id = msg._id || msg.id;
  const i = list.findIndex(m => (m._id || m.id) === id);
  if (i === -1) list.push(msg);
  else list[i] = { ...list[i], ...msg };
  return list.sort(sortByCreatedAt);
};

const initialState = {
  byChatId: {},        // { [chatId]: Message[] }
  loadingByChat: {},
  errorByChat: {},
  typingFrom: null,
  activePeerId: undefined,
};

// ➜ ajoute setMessages (hydrate/replace proprement un chat) et garde ws reducers
const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setActivePeer(state, action) {
      state.activePeerId = action.payload;
    },
    setMessages(state, action) {
      const { chatId, items } = action.payload || {};
      state.byChatId[chatId] = (items || []).slice().sort(sortByCreatedAt);
    },
    wsNewMessage(state, action) {
      const msg = action.payload;
      if (!msg?.chatId) return;
      state.byChatId[msg.chatId] = upsert(state.byChatId[msg.chatId], msg);
    },
    wsMessageUpdated(state, action) {
      const msg = action.payload;
      if (!msg?.chatId) return;
      state.byChatId[msg.chatId] = upsert(state.byChatId[msg.chatId], msg);
    },
    wsMessageDeleted(state, action) {
      const { messageId, chatId } = action.payload || {};
      if (chatId) {
        state.byChatId[chatId] =
          (state.byChatId[chatId] || []).filter(m => (m._id || m.id) !== messageId);
      }
    },
    wsTyping(state, action) {
      state.typingFrom = action.payload?.fromUserId || action.payload?.from || null;
    },
    clearTyping(state) {
      state.typingFrom = null;
    },
    setLoading(state, action) {
      const { chatId, value } = action.payload;
      state.loadingByChat[chatId] = value;
    },
    setError(state, action) {
      const { chatId, value } = action.payload;
      state.errorByChat[chatId] = value;
    },
  },
});

export const {
  setActivePeer,
  setMessages,
  wsNewMessage,
  wsMessageUpdated,
  wsMessageDeleted,
  wsTyping,
  clearTyping,
  setLoading,
  setError,
} = messagesSlice.actions;

export default messagesSlice.reducer;
